import api from "../api";
import { GET_ERRORS,GET_SITES, GET_SITE } from "./types";

export const createSite = (site, history) => async dispatch => {
    
  try {
    await api.post("/sites/", site);
    history.push("/site-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const updateSite = (site, history) => async dispatch => {
  try {
    await api.put(`/sites/update`, site);
    history.push("/site-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data
    });
  }
};

export const getSites = () => async dispatch => {
  const res = await api.get("/sites/find-all");
  dispatch({
    type: GET_SITES,
    payload: res.data
    
  });

  dispatch({
    type: GET_ERRORS,
    payload: {}
  });
  
};

export const getSite = (id, history) => async dispatch => {
  try {
    
    const res = await api.get(`/sites/find-by-id/${id}`);
    
    dispatch({
      type: GET_SITE,
      payload: res.data
    });
  } catch (error) {
   
    history.push("/home");
  }
};

